import { formatDays } from "./formatDays";

export const flattenLeaveRecord = record => {
  const periods = record.periods || [];
  const isMulti = periods.length > 1;
  const first = periods[0] || {};

  return {
    leaveId: record.id,
    id: record.id,
    type: first.type,
    employeeId: record.employeeId,
    substituteEmployeeIds: [...new Set(periods.map(p => p.substituteEmployeeId).filter(Boolean))],
    reasonId: record.reasonId,
    reason: record.reason,
    staffRequest: record.staffRequest,
    periods,
    startDate: isMulti ? null : first.dateFrom,
    endDate: isMulti ? null : first.dateTo,
    numberOfDays: isMulti ? `${periods.length} периода` : formatDays(first.numberOfDays),
  };
};
